import React, { FC } from 'react';

import reservationFlag from '../../../../assets/images/svg/reservation-limit-flag.svg';
import { formatPercents } from '../../../../formatters';
import { cn, resultIf } from '../../../../utils';

import './ProjectProgress.scoped.scss';

interface Props {
  percentage: number;
  markerPercentage?: number;
  variant?: 'reservation';
  reservationPercentage?: number;
}

const ProjectProgress: FC<Props> = ({
  percentage,
  markerPercentage,
  variant,
  reservationPercentage,
}) => {
  const isFinished = (): boolean => {
    return percentage >= 100;
  };

  const cssVars = {
    '--fill-width': `${percentage}%`,
    ...(markerPercentage !== undefined && {
      '--marker-pos': `${Math.min(markerPercentage, 100)}%`,
    }),
    ...(reservationPercentage !== undefined && {
      '--reservation-width': `${Math.min(reservationPercentage, 100 - percentage)}%`,
    }),
  } as React.CSSProperties;

  return (
    <div className="project-progress" style={cssVars}>
      <div
        className={cn(
          'project-progress__filled',
          resultIf(isFinished(), 'finished'),
          resultIf(variant === 'reservation', 'reservation')
        )}
      />
      {reservationPercentage !== undefined && reservationPercentage > 0 && (
        <div className="project-progress__reservation" />
      )}
      {markerPercentage !== undefined && (
        <div className="project-progress__marker">
          <img src={reservationFlag} alt="" />
        </div>
      )}
      <div className="project-progress__percentage">{formatPercents(percentage)}</div>
    </div>
  );
};

export default ProjectProgress;
